"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @deckee/app-main
 * App main integration endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: jason@deckee.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarkerItemToJSON = exports.MarkerItemFromJSONTyped = exports.MarkerItemFromJSON = exports.instanceOfMarkerItem = void 0;
var runtime_1 = require("../runtime");
var MarkerItemAddedToMapBy_1 = require("./MarkerItemAddedToMapBy");
var MarkerItemContent_1 = require("./MarkerItemContent");
var MarkerItemCta_1 = require("./MarkerItemCta");
var ReverseGeocodingAddressLookupRequest_1 = require("./ReverseGeocodingAddressLookupRequest");
/**
 * Check if a given object implements the MarkerItem interface.
 */
function instanceOfMarkerItem(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "markerType" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "latLon" in value;
    isInstance = isInstance && "hidden" in value;
    isInstance = isInstance && "content" in value;
    isInstance = isInstance && "image" in value;
    isInstance = isInstance && "addedToMapBy" in value;
    isInstance = isInstance && "editable" in value;
    isInstance = isInstance && "flaggedAsDuplicate" in value;
    isInstance = isInstance && "flaggedAsIncorrect" in value;
    isInstance = isInstance && "lastEditedBy" in value;
    isInstance = isInstance && "lastEditedAt" in value;
    isInstance = isInstance && "discColour" in value;
    isInstance = isInstance && "partner" in value;
    isInstance = isInstance && "markerImage" in value;
    isInstance = isInstance && "cta" in value;
    isInstance = isInstance && "numberOfComments" in value;
    return isInstance;
}
exports.instanceOfMarkerItem = instanceOfMarkerItem;
function MarkerItemFromJSON(json) {
    return MarkerItemFromJSONTyped(json, false);
}
exports.MarkerItemFromJSON = MarkerItemFromJSON;
function MarkerItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'markerType': json['markerType'],
        'createdAt': json['createdAt'],
        'title': json['title'],
        'description': json['description'],
        'latLon': (0, ReverseGeocodingAddressLookupRequest_1.ReverseGeocodingAddressLookupRequestFromJSON)(json['latLon']),
        'hidden': json['hidden'],
        'geoJson': !(0, runtime_1.exists)(json, 'geoJson') ? undefined : json['geoJson'],
        'content': (0, MarkerItemContent_1.MarkerItemContentFromJSON)(json['content']),
        'image': json['image'],
        'addedToMapBy': (0, MarkerItemAddedToMapBy_1.MarkerItemAddedToMapByFromJSON)(json['addedToMapBy']),
        'editable': json['editable'],
        'flaggedAsDuplicate': json['flaggedAsDuplicate'],
        'flaggedAsIncorrect': json['flaggedAsIncorrect'],
        'lastEditedBy': json['lastEditedBy'],
        'lastEditedAt': json['lastEditedAt'],
        'discColour': json['discColour'],
        'partner': json['partner'],
        'markerImage': json['markerImage'],
        'cta': (0, MarkerItemCta_1.MarkerItemCtaFromJSON)(json['cta']),
        'numberOfComments': json['numberOfComments'],
    };
}
exports.MarkerItemFromJSONTyped = MarkerItemFromJSONTyped;
function MarkerItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'markerType': value.markerType,
        'createdAt': value.createdAt,
        'title': value.title,
        'description': value.description,
        'latLon': (0, ReverseGeocodingAddressLookupRequest_1.ReverseGeocodingAddressLookupRequestToJSON)(value.latLon),
        'hidden': value.hidden,
        'geoJson': value.geoJson,
        'content': (0, MarkerItemContent_1.MarkerItemContentToJSON)(value.content),
        'image': value.image,
        'addedToMapBy': (0, MarkerItemAddedToMapBy_1.MarkerItemAddedToMapByToJSON)(value.addedToMapBy),
        'editable': value.editable,
        'flaggedAsDuplicate': value.flaggedAsDuplicate,
        'flaggedAsIncorrect': value.flaggedAsIncorrect,
        'lastEditedBy': value.lastEditedBy,
        'lastEditedAt': value.lastEditedAt,
        'discColour': value.discColour,
        'partner': value.partner,
        'markerImage': value.markerImage,
        'cta': (0, MarkerItemCta_1.MarkerItemCtaToJSON)(value.cta),
        'numberOfComments': value.numberOfComments,
    };
}
exports.MarkerItemToJSON = MarkerItemToJSON;
